import { useCallback, useEffect } from 'react';

import { useQuery } from '../../../contexts/RouterContext';

type Params = {
  selectedPath: string;
};

/**
 * We store the selected path in the URL, this hook manages it.
 */
export function useSelectedPath() {
  const [queryParams, setQueryParams] = useQuery<Params>();

  //  Set the selected path in the URL.
  const setSelectedPath = useCallback((selectedPath?: string | null) => {
    setQueryParams({ selectedPath: selectedPath ?? '/' });
  }, [setQueryParams]);

  useEffect(() => {
    //  Set the path to the root path if it's not set.
    if (!queryParams.selectedPath) {
      setSelectedPath('/');
    }
  }, [queryParams.selectedPath, setSelectedPath]);

  return {
    selectedPath: queryParams.selectedPath,
    setSelectedPath,
  };
}
